function countAppts() {
    const appts = document.querySelectorAll("#schedule input").length;
    const apptsElem = document.getElementById("appts");
    if (apptsElem) apptsElem.textContent = appts;
}

function addAppt(time) {
    const appt = new Date(time).toString().split(" ");
    const schedule = document.getElementById("schedule");
    if (!schedule) return;

    const tr = document.createElement("tr");
    const td = document.createElement("td");
    const input = document.createElement("input");
    input.type = "checkbox";
    input.checked = true;
    input.id = "schedule_";
    input.name = "schedule[]";
    input.value = time.toUTCString();

    const labelText = time.toUTCString().substr(0, time.toUTCString().lastIndexOf(":"));
    td.appendChild(input);
    td.appendChild(document.createTextNode(" " + labelText));
    tr.appendChild(td);

    // Insert after the last row
    const lastRow = schedule.querySelector("tr:last-child");
    if (lastRow) {
        lastRow.parentNode.insertBefore(tr, lastRow.nextSibling);
    } else {
        schedule.appendChild(tr);
    }
}

function addslots() {
    const reps = parseInt(document.getElementById("numappts").value, 10);
    const dur = parseInt(document.getElementById("duration").textContent, 10);
    const date = document.getElementById("day").value.split(",");
    const year = parseInt(date[0], 10);
    const month = parseInt(date[1], 10) - 1;
    const day = parseInt(date[2], 10);
    let hour = parseInt(document.getElementById("hours").value, 10);
    const minute = parseInt(document.getElementById("minutes").value, 10);
    const twice = document.getElementById("double").value === 'true';
    const pm = document.getElementById("ampm").value === 'true';
    if (pm) {
        hour += 12;
    }
    const apptime = new Date(Date.UTC(year, month, day, hour, minute));

    for (let k = 0; k < reps; k++) {
        const a = new Date(apptime);
        const ts = new Date(a.setSeconds(k * (dur * 60)));
        addAppt(ts);
        if (twice) {
            addAppt(ts);
        }
    }
    countAppts();
    const step2 = document.getElementById("step2");
    if (step2) step2.style.visibility = "visible";
}

document.addEventListener("DOMContentLoaded", function() {
    countAppts();
    const submitBtn = document.getElementById("submitappts");
    if (submitBtn) submitBtn.addEventListener("click", addslots);
});

